import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { JsonObject } from '@angular-devkit/core';

import { CommonService } from "../../../_common/_service/user.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {
  token: any;
  companyaddress: any;
  emailsus: any;
  visitus: any;
  customerService: any;
  whatsappSupport: any;
  companyname: any;
  submitted = false;
  stringJson: any;
  stringObject: any;
  currentUser: any;
  serviceCode: any;
  saveFeedBackForm: FormGroup;
  SubjectList: any;
  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService)
  {
    this.saveFeedBackForm = this.fb.group({
      name: [null, [Validators.required]],
      emailid: [null, [Validators.required, Validators.email]],
      mobileno: [null, [Validators.required, Validators.maxLength(20), Validators.minLength(8)]],
      subject: [null, [Validators.required]],
      msg: [null, [Validators.required]]
    })
  }

  ngOnInit() {
    
    //else {
    //  this._service.callMethodOfSecondComponent();
    //}

    this.emailsus = localStorage.getItem('emailsus');
    this.visitus = localStorage.getItem('visitus');
    this.customerService = localStorage.getItem('customerService');
    this.whatsappSupport = localStorage.getItem('whatsappSupport');
    this.companyname = localStorage.getItem('companyname');
    this.companyaddress = localStorage.getItem('companyaddress');

    //this.token = this.tokenStorageService.getUser();

    if (this.companyname) {
      this.currentUser = this.tokenStorageService.getUser();
      this.getSubjectList();
    }

  }

  get f() { return this.saveFeedBackForm.controls; }
  Back() {

    this.router.navigate(['/Go-on']);
  }

  getSubjectList() {
    debugger;
    this.submitted = false;

    this.authService.getSubjectList(this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      
      if (response.apiStatus == true) {
        this.SubjectList = response.apiData;

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  save(post: any) {
    //
    this.submitted = true;
    if (this.saveFeedBackForm.valid) {
     
    this.authService.saveFeedBackContact(post, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
        
        if (response.apiStatus == true) {
          this.submitted = false;
          this.saveFeedBackForm.reset();
          this.toastr.success(response.apiMessage, 'Success');

        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }
}
